<div class="card m-3"> 
    <div class="card-body">
        
        <form (ngSubmit)="saveManufacturer()">
    <label>Name:</label>
    <input type="text" [(ngModel)]="manufacturer.name" name="Name" required />
  
    <label>Country:</label>
    <input type="text" [(ngModel)]="manufacturer.country" name="Country" required />
  
    <button type="submit">Save Changes</button>
  </form>
  </div>
  </div>